import React from "react";
import { Archive, Copy, Eye, FlaskConical, Pause, Pencil, Play, Rocket, Trash2, Zap } from "lucide-react";
import IconAction from "../../../components/IconAction";

// Row actions of the Rule list. Write actions (and Test run, which reads live rows) are shown only when `canManage`
// (Super Admin). `busy` = { id, action } of a request in flight.
export default function RuleRowActions({ row, canManage, busy, onView, onEdit, onTestRun, onRunNow, onActivate, onPause, onResume, onClone, onArchive, onDelete }) {
  const isBusy = (action) => busy?.id === row.id && busy.action === action;
  const anyBusy = busy?.id === row.id;
  const archived = row.status === "ARCHIVED";
  return (
    <div className="flex items-center gap-1">
      <IconAction label="View" icon={Eye} onClick={() => onView(row)} busy={isBusy("view")} disabled={anyBusy} />
      {canManage && (
        <>
          {!archived && <IconAction label="Edit" icon={Pencil} tone="primary" onClick={() => onEdit(row)} disabled={anyBusy} />}
          {!archived && <IconAction label="Test run" icon={FlaskConical} onClick={() => onTestRun(row)} disabled={anyBusy} />}
          {!archived && <IconAction label={row.published_version_no ? "Activate again (publish the saved draft)" : "Activate"} icon={Rocket} tone="primary" onClick={() => onActivate(row)} busy={isBusy("activate")} disabled={anyBusy} />}
          {row.status === "ACTIVE" && <IconAction label="Run now (sends what is due)" icon={Zap} onClick={() => onRunNow(row)} busy={isBusy("run")} disabled={anyBusy} />}
          {row.status === "ACTIVE" && <IconAction label="Pause" icon={Pause} onClick={() => onPause(row)} busy={isBusy("pause")} disabled={anyBusy} />}
          {row.status === "PAUSED" && <IconAction label="Resume" icon={Play} tone="primary" onClick={() => onResume(row)} busy={isBusy("resume")} disabled={anyBusy} />}
          <IconAction label="Copy as a draft" icon={Copy} onClick={() => onClone(row)} busy={isBusy("clone")} disabled={anyBusy} />
          {!archived && <IconAction label="Archive" icon={Archive} onClick={() => onArchive(row)} busy={isBusy("archive")} disabled={anyBusy} />}
          {["DRAFT", "ARCHIVED"].includes(row.status) && !row.is_system && <IconAction label="Delete" icon={Trash2} tone="danger" onClick={() => onDelete(row)} disabled={anyBusy} />}
        </>
      )}
    </div>
  );
}
